import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CButton, CCloseButton } from '@coreui/react-pro';
import PropTypes from 'prop-types';

import { setShowPopup } from '../../../actions/general';
import { Waiting } from '../Loadings';

const CreatePopup = ({ object, formId, children, className, options, textSubmit, disabled, onClose }) => {
     const dispatch = useDispatch();
     const isWaiting = useSelector((state) => state.general.isWaiting);

     const handleCancelButtonClick = () => {
          onClose && onClose(false);

          dispatch(setShowPopup());
     };
     return (
          <CModal alignment="center" visible={true} className={className}>
               {!options.oneField && (
                    <CModalHeader closeButton={false}>
                         <CModalTitle>Create New {object}</CModalTitle>
                         <CCloseButton onClick={handleCancelButtonClick} />
                    </CModalHeader>
               )}

               <CModalBody>{children}</CModalBody>
               <CModalFooter>
                    <div className="modal-footer-start">
                         <CButton type="submit" color={options.colorSave} className="me-3" form={formId} disabled={isWaiting || disabled}>
                              <Waiting isLoading={isWaiting}>{textSubmit}</Waiting>
                         </CButton>
                         <CButton color={options.colorCancel} onClick={handleCancelButtonClick}>
                              Cancel
                         </CButton>
                    </div>
               </CModalFooter>
          </CModal>
     );
};

CreatePopup.propTypes = {
     object: PropTypes.string,
     formId: PropTypes.string,
     children: PropTypes.any,
     className: PropTypes.string,
     options: PropTypes.object,
     disabled: PropTypes.bool,
};

CreatePopup.defaultProps = {
     className: 'admin-popup-form',
     textSubmit: 'Save changes',
     options: {
          oneField: false,
          colorSave: 'primary',
          colorCancel: 'secondary',
     },
};

export default CreatePopup;
